import z from 'zod'

export const ConvexConfigSchema = z
  .object({
    shouldPromptForConvexGame: z.boolean(),
    isConvexPracticeGamesEnabled: z.boolean(),
    convex_deploy_url: z.optional(z.string())
  })
  .default({
    shouldPromptForConvexGame: false,
    isConvexPracticeGamesEnabled: true,
    convex_deploy_url: undefined
  })
